<template>
    <page>
        <module>
            <module-column enable-flex>
                <c-table ref="dic_table" @row-click="dicDetailSearchHandle">
                    <c-table-column label="字典名称" name="dic_name" width="120"></c-table-column>
                    <c-table-column label="备注" name="dic_desc" width="200"></c-table-column>
                </c-table>
            </module-column>

            <module-column enable-flex>
                <m-operate>
                    <c-button power="b_dictionary_edit" color="sys" @click="add()" :disabled="add_detail_btn">
                        新增字典值
                    </c-button>
                </m-operate>

                <c-table ref="dic_detail_table" width="60" :paging="false">
                    <c-table-column label="字典值" name="name" width="120"></c-table-column>
                    <c-table-column label="备注" name="remark" width="200"></c-table-column>
                    <c-table-column
                            type="sort"
                            label="排序"
                            name="sort_id"
                            power="b_standard_logistics_edit"
                            @sort="sortHandle"
                    >
                    </c-table-column>
                    <c-table-column type="button" fixed="right" label="操作" width="120">
                        <template v-slot="{data}">
                            <c-table-button power="b_advert_edit" @click="edit(data)">编辑</c-table-button>
                            <c-table-button power="b_advert_del" @click="del(data)">删除</c-table-button>
                        </template>
                    </c-table-column>
                </c-table>
            </module-column>
        </module>

        <c-dialog ref="editDialog" :title="editState ? '编辑字典值' : '新增字典值'" width="600" @resolve="submitForm">
            <c-form ref="editForm">
                <c-form-item type="hidden" name="id"></c-form-item>
                <c-form-item type="input" label="所属字典" name="dic_name" disabled readonly></c-form-item>
                <c-form-item type="input" label="字典值名称" name="name" maxlength="20" required></c-form-item>
                <c-form-item type="textarea" label="备注" name="remark" maxlength="500"></c-form-item>
            </c-form>
        </c-dialog>
    </page>
</template>

<script>
export default {
    name: 'm_advert',
    data() {
        return {
            dic_id: 0,
            dic_name: '',
            add_detail_btn: true,
            linkType: 'app',
            supportFlagName: {
                1: 'PC',
                2: '移动端'
            },
            showTypeName: {
                1: '自定义',
                2: '图片轮播',
                3: '静态图片'
            },
            advertStateName: {
                0: '未生效',
                1: '生效中',
                2: '已失效'
            },
            editState: false
        }
    },
    mounted() {
        this.dicSearchHandle();
    },
    methods: {
        dicSearchHandle() {
            this.$refs.dic_table.load({
                url: '/operation/dic/list',
            });
        },
        dicDetailSearchHandle(row) {
            this.dic_id = row.data.id;
            this.dic_name = row.data.dic_name;
            this.add_detail_btn = false;
            this.$refs.dic_detail_table.load({
                url: '/operation/dic/detail/list',
                data: {
                    dic_id:this.dic_id
                }
            });
        },
        add() {
            this.$refs.editForm.clear();
			this.editState = false;
            this.$refs.editForm.set({
                dic_name:this.dic_name
            });
            this.$refs.editDialog.open();
        },
        edit(val) {
            val.dic_name = this.dic_name
            this.editState = true;
            this.$refs.editForm.set(val);
            this.$refs.editDialog.open();
        },
        del(val) {
            this.$confirm({
                text: '确定要删除字典值数据【'+val.name+'】吗？',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/operation/dic/detail/remove',
                        data: {id: val.id},
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '操作成功',
                                icon: 'success'
                            });
                            this.$refs.dic_detail_table.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        },
        //提交数据
        submitForm(stop) {
            stop();
            let submitUrl = '/operation/dic/detail/add';
            if (this.editState) {
                submitUrl = '/operation/dic/detail/edit';
            }
            this.$refs.editForm.submit({
                url: submitUrl,
                rule: {
                    name: [{
                        type: 'empty',
                        word: '请填写字典值名称'
                    }]
                },
                dataFormatter: data => {
                    data.dic_id = this.dic_id;
                    return data;
                },
                success: (data, res) => {
                    this.$message({
                        text: '操作成功',
                        icon: 'success'
                    });
                    this.$refs.dic_detail_table.update();
                    this.$refs.editDialog.close();
                },
            });
        },
        //排序
        sortHandle(row, type, next) {
            //row.prev() 上一行数据
            //row.next() 下一行数据
            let submitData = {};
            submitData.dic_id = this.dic_id;
            if (type == 'top' || type == 'bottom') {
                submitData.type = type;
                submitData.id = row.data.id;
            }
            if (type == 'up') {
                submitData.id1 = row.data.id;
                submitData.id2 = row.prev().data.id;
            }
            if (type == 'down') {
                submitData.id1 = row.data.id;
                submitData.id2 = row.next().data.id;
            }
            this.request({
                url: '/operation/dic/detail/sort',
                data: submitData,
                loading: true,
                success: data => {
                    if (type == 'top' || type == 'bottom') {
                        this.$refs.dic_detail_table.update();
                    } else {
                        next();
                    }
                }
            });
        },
    }
}
</script>